export default "__VITE_ASSET__1fd92fbb__"